const ZoomV9 = (() => {
  function experienceMarkup(productContext = false) {
    const cards = productContext
      ? [
          ['✓', 'Professional fitting', 'Support with frame fit, comfort and everyday use.'],
          ['◇', 'After-sales care', 'Clear support for adjustments, maintenance and product questions.'],
          ['◎', 'Authentic eyewear', 'Original eyewear with product details available before purchase.']
        ]
      : [
          ['✓', 'Professional guidance', 'Help choosing frames around fit, comfort and everyday needs.'],
          ['◇', 'Store experience', 'Try frames in person and get practical support from the optical team.'],
          ['◎', 'After-sales support', 'Clear assistance for adjustments, maintenance and product questions.']
        ];

    return `<div class="zoom-v102-experience">${cards.map(([icon,title,text]) => `
      <article class="zoom-v102-experience-card">
        <span class="zoom-v102-icon" aria-hidden="true">${icon}</span>
        <strong>${title}</strong>
        <p>${text}</p>
      </article>`).join('')}</div>`;
  }

  function fixEmptyReviews(scope = document) {
    scope.querySelectorAll('.zoom-v9-proof-empty').forEach((el) => {
      if (el.dataset.zoomV102Done === 'true') return;
      el.dataset.zoomV102Done = 'true';
      el.classList.add('zoom-v102-replaced');
      el.innerHTML = experienceMarkup(false);
    });

    scope.querySelectorAll('.zoom-v9-review-empty').forEach((el) => {
      if (el.dataset.zoomV102Done === 'true') return;
      el.dataset.zoomV102Done = 'true';
      el.classList.add('zoom-v102-replaced');
      el.innerHTML = experienceMarkup(true);
    });

    scope.querySelectorAll('.z6-rating-summary').forEach((summary) => {
      if (!/No reviews yet/i.test(summary.textContent || '')) return;
      summary.classList.add('zoom-v102-rating-fallback');
      summary.innerHTML = '<strong>Customer care available</strong><span>Product reviews will appear here when review data is connected.</span>';
    });

    scope.querySelectorAll('.ze-product__rating-line').forEach((line) => {
      if (!/No reviews yet/i.test(line.textContent || '')) return;
      line.innerHTML = '<span aria-hidden="true">✓</span><span>Customer care & product reviews</span>';
    });
  }

  function init(scope = document) {
    document.documentElement.classList.add('zoom-v9-ready');
    fixEmptyReviews(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  return { init };
})();
